import { inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';

import { TellentHttpApiService } from '@core/tellent-http-legacy';
import { PositionSkillEntity } from '@core/tellent-skills-types';
import { ORG_GUID } from '@core/tellent-types';

@Injectable({ providedIn: 'root' })
export class PositionSkillsHttpClient {
  private readonly httpApi = inject(TellentHttpApiService);
  private readonly orgGuid = inject(ORG_GUID)!;

  public fetchPositionSkills(positionGuid: string): Observable<PositionSkillEntity> {
    return this.httpApi
      .get(`/positions/org/${this.orgGuid}/positions/${positionGuid}/skills`, null, {
        skipCompany: true,
      })
      .pipe(take(1));
  }

  public assignSkill(
    positionGuid: string,
    skillId: number,
    proficiencyId: number,
  ): Observable<string> {
    return this.httpApi
      .post(
        `/positions/org/${this.orgGuid}/positions/${positionGuid}/skills/assign`,
        null,
        { skillId, proficiencyId },
        { skipCompany: true },
      )
      .pipe(take(1));
  }

  public unassignSkill(positionGuid: string, skillId: number): Observable<string> {
    return this.httpApi
      .post(
        `/positions/org/${this.orgGuid}/positions/${positionGuid}/skills/unassign`,
        null,
        { skillId },
        { skipCompany: true },
      )
      .pipe(take(1));
  }

  public unassignSkillMapping(
    positionGuid: string,
    skillMappingId: number,
    levelId: number,
  ): Observable<string> {
    return this.httpApi
      .post(
        `/positions/org/${this.orgGuid}/positions/${positionGuid}/skill-mappings/unassign`,
        null,
        { skillMappingId, levelId },
        { skipCompany: true },
      )
      .pipe(take(1));
  }

  public updateSkill(
    positionGuid: string,
    skillId: number,
    proficiencyId: number,
  ): Observable<string> {
    return this.httpApi
      .post(
        `/positions/org/${this.orgGuid}/positions/${positionGuid}/skills/update`,
        null,
        { skillId, proficiencyId },
        { skipCompany: true },
      )
      .pipe(take(1));
  }

  public assignSkillMapping(
    positionGuid: string,
    skillMappingId: number,
    levelId: number,
  ): Observable<string> {
    return this.httpApi
      .post(
        `/positions/org/${this.orgGuid}/positions/${positionGuid}/skill-mappings/assign`,
        null,
        { skillMappingId, levelId },
        { skipCompany: true },
      )
      .pipe(take(1));
  }
}
